import React, { useState } from "react";
import { Row, Col, Button, Space, Typography, Tooltip, message } from "antd";
import Scrollbars from "react-custom-scrollbars";
import InfiniteScroll from "react-infinite-scroll-component";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import defaultImage from "../../../../assets/images/no-image.svg";
import userIcon from "../../../../assets/images/userId.svg";
import DiscountIcon from "../../../../assets/images/discountperIcon.svg";
import Offers from "../../../../assets/images/promoTag.svg";
import DeleteImg from "../../../../assets/images/delete1.svg";
import { getMultilingualText } from "../../../../utils/getMultilingualText";
import messages from "../../../../errors/messages.en-IN.json";
import db from "../../../../database";
import useRestaurantStore from "../../../../stores/useRestaurantStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import PaymentDataPopup from "../../Core/payment/PaymentDataPopup";

const { Text } = Typography;

const OrderDetailsSidebar = ({
  cart,
  userPreferences,
  saleType,
  selectedTable,
  guestName,
  selectedProductId,
  setSelectedProductId,
  setSelectedProductInCart,
  currenciesList,
  charges,
  showCharges,
  pricePrecision,
  handleDeletePayment,
  manualDiscountRestaurant,
  selectedPayment,
  paymentVisible,
  amount,
  tillData,
  selectedPaymentMethod,
  setNumb,
  requestPayment,
  handleOrderCompletion,
  setSelectedPayment,
  setTableCards,
  setMainTableData,
  setOcupiedTablesData,
  setReservedTablesData,
  markTableBillRequested,
  isSplitBill,
  splitCarts,
  removeSplit,
  setSplitCarts,
  setCurrentSplitIndex,
  setCart,
  setSplitBillScreen,
  setIsSplitBill,
  setKeyValue,
  recordState,
  setShowOrderCompleteFlag,
  processOrder,
  setPaymentVisible,
  restaurantButtonLoading,
  setRestaurantButtonLoading,
}) => {
  // TSK-2934: local popup state, self-contained (not the shared usePaymentFlow.js
  // state) — this button's post-payment tail (markTableBillRequested,
  // handleOrderCompletion, table-card refresh, split-bill regeneration) is specific
  // to this component and isn't replicated by the shared handlePaymentDataSubmit,
  // same reasoning as the existing PaymentCheckout.js fix.
  const [paymentDataPopupOpen, setPaymentDataPopupOpen] = useState(false);

  // Extracted verbatim from the "Add Payment"/"Pay Bill" button's onClick below —
  // pure lift, no behavior change — so it can be called either directly or from
  // handlePaymentDataConfirm after the reference-data popup is submitted.
  const completeGiftCardOrLoyaltyPayment = async (updatedCart) => {
    setNumb(0);
    const isReturnFlow = selectedPaymentMethod?.isReturns === "Y";
    if (!isReturnFlow && selectedPaymentMethod?.name?.toLowerCase() !== "cash") {
      const chargesTotal = (cart.tip || 0) + (cart.serviceCharge || 0) + (cart.packingCharge || 0) + (cart.deiveryCharge || cart.deliveryCharge || 0);
      if (Number((cart.paid + parseFloat(amount)).toFixed(pricePrecision)) > Number((cart.total + chargesTotal).toFixed(pricePrecision))) {
        message.warning(`${messages.errors.cart.overpayment_not_allowed}`);
        return;
      }
    }
    // F-07: pass the caller's updated cart (with fresh paymentReferenceData) through,
    // since the `cart` closure variable here won't reflect a setCart done just before this call.
    requestPayment(selectedPaymentMethod, amount, undefined, undefined, undefined, updatedCart);
    if (useRestaurantStore.getState().dineIn === "Y") {
      await markTableBillRequested();
    }
    await handleOrderCompletion(amount);
    setSelectedPayment(false);
    if (useRestaurantStore.getState().dineIn === "Y") {
      const updatedTableData = await db.tableData.toArray();
      setTableCards(updatedTableData);
      setMainTableData(updatedTableData);
      const updatedOccupiedData = updatedTableData.filter((table) => table?.statusType === "OCU" || table.statusType === "ONG");
      setOcupiedTablesData(updatedOccupiedData);
      const updatedReservedData = updatedTableData.filter((table) => table.statusType === "RES");
      setReservedTablesData(updatedReservedData);
    }
    if (isSplitBill) {
      const updatedSplits = splitCarts.filter((split) => split.splitNo !== removeSplit.splitNo);
      if (updatedSplits.length > 0) {
        const regeneratedSplits = updatedSplits.map((split, index) => {
          const sOrderID = uuidv4().replace(/-/g, "").toUpperCase();
          return {
            ...split,
            payments: [],
            isSplit: "Y",
            sOrderID,
            referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
            giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
            couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
          };
        });
        setSplitCarts(regeneratedSplits);
        setCurrentSplitIndex(0);
        setCart(regeneratedSplits[0]);
        setSplitBillScreen(true);
      } else {
        processOrder();
        setIsSplitBill(false);
        setSplitCarts([]);
        setCurrentSplitIndex(0);
        setKeyValue("0");
      }
      useRestaurantStore.getState().setTableName(recordState);
    }
  };

  // TSK-2934: popup onSubmit — stashes captured fields the same way PaymentCheckout.js
  // and paymentController.js's addAmount() do (activeCart.paymentReferenceData), then
  // resumes the exact same tail as the direct-payment path above.
  const handlePaymentDataConfirm = async (paymentData) => {
    setPaymentDataPopupOpen(false);
    const activeCart = useCartStore.getState().cart || cart;
    // F-07: write through setCart instead of mutating the store object in place.
    const updatedCart = {
      ...activeCart,
      paymentReferenceData: { ...(activeCart.paymentReferenceData || {}), [selectedPaymentMethod.finPaymentmethodId]: paymentData },
    };
    setCart(updatedCart);
    try {
      setRestaurantButtonLoading?.(true);
      await completeGiftCardOrLoyaltyPayment(updatedCart);
    } catch (error) {
      console.error("Payment Error:", error);
    } finally {
      setRestaurantButtonLoading?.(false);
    }
  };

  return (
    <div
      style={{
        background: "#fff",
        height: "100vh",
        width: "31%",
        position: "relative",
        fontSize: "1vw",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "2vh 1vw 0 1vw",
        }}
      >
        <span
          style={{
            fontWeight: 600,
            fontSize: "1.5em",
            color: "#0F0718",
            fontFamily: "Inter",
          }}
        >
          {getMultilingualText("Order Details")}
        </span>
        <span style={{ fontWeight: 500, fontSize: "1em", color: "#929098" }}>{dayjs(cart.orderTime).format(userPreferences.dateFormat)}</span>
      </div>
      {saleType === "DI" && (
        <p
          style={{
            padding: "0 1vw",
            fontSize: "1em",
            color: "#0F0718",
            fontWeight: 500,
            marginBottom: "5px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {selectedTable?.name}
            <span style={{ fontSize: "1em", fontFamily: "Arial, sans-serif", marginLeft: "1rem" }}>{guestName}</span>
          </div>
        </p>
      )}
      <button
        style={{
          marginLeft: "0.9vw",
          color: "#0F0718",
          backgroundColor: "#fff",
          border: "1px solid #92909880",
          fontSize: "0.85em",
          borderRadius: "4px",
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0.2vh 0.5vw",
          cursor: "pointer",
          alignSelf: "flex-start",
        }}
      >
        <img src={userIcon} style={{ height: 15, width: "1.5vw", marginRight: "0.2vw" }} />
        {cart?.customer?.name}
      </button>

      <hr style={{ color: "#929098", width: "93%" }} />
      <div style={{ flex: 1, overflow: "hidden", minHeight: 0 }}>
      <Scrollbars
        autoHide
        style={{ height: "100%" }}
      >
        <InfiniteScroll
          dataLength={cart.items.length}
          hasMore={true}
          endMessage={
            <p className="center">
              <b>Yay! you have seen it all</b>
            </p>
          }
          style={{ overflowX: "hidden" }}
        >
          {cart.items
            .filter((item) => item.isCanceled !== "Y")
            .map((item) => {
              return (
                <div style={{ padding: "6px 10px" }}>
                  <div
                    style={{ fontSize: "0.9vw", backgroundColor: selectedProductId === item.lineId ? "#f0f0f0" : "transparent" }}
                    onClick={() => {
                      setSelectedProductId(item.lineId);
                      setSelectedProductInCart(item);
                    }}
                  >
                    <Row>
                      <Col span={3}>
                        <img
                          src={item.imageurl || defaultImage}
                          alt={item.productAliasName ? item.productAliasName : item.name}
                          style={{
                            // height: "8vh",
                            height: item.description ? "6.5vh" : "6vh",
                            maxWidth: "100%",
                            objectFit: "cover",
                            borderRadius: "7px",
                          }}
                        />
                      </Col>
                      <Col
                        span={16}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          paddingLeft: "0.5vw",
                          marginRight: "30px",
                        }}
                      >
                        <Tooltip title={item.productAliasName ? item.productAliasName : item.name} placement="top">
                          <Text
                            style={{
                              fontSize: "1em",
                              fontWeight: "500",
                              color: "#0F0718",
                              marginRight: "0.3rem",
                              maxWidth: "18vw",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.productAliasName ? item.productAliasName : item.name}
                          </Text>
                        </Tooltip>
                        <Text
                          style={{
                            fontSize: "0.8em",
                            color: "#929098",
                            fontWeight: 400,
                          }}
                        >
                          {item.description}
                        </Text>
                        <Text>
                          {" "}
                          {item?.selectedAddons?.map((subitem) => (
                            <Row>
                              <Col span={14}>
                                <p style={{ fontSize: "0.8em", color: "#929098", marginBottom: 0 }}>+ {subitem.name}</p>
                              </Col>
                            </Row>
                          ))}
                        </Text>
                        <Text
                          style={{
                            fontWeight: 600,
                            fontSize: "1.1em",
                            color: "#0F0718",
                          }}
                        >
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {item.sunitprice?.toFixed(pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                        </Text>
                      </Col>
                      <Col
                        span={2}
                        style={{
                          textAlign: "center",
                          color: "#0F0718",
                          fontWeight: 500,
                          fontSize: "1.1em",
                        }}
                      >
                        X {item.weight}
                      </Col>
                      <span
                        style={{
                          background: Math.abs(item.discount) > 0 ? "#F8C519" : "",
                          borderRadius: "3px",
                          padding: "0.25vw",
                          display: item.discountName ? "" : "none",
                          fontSize: "0.7em",
                          marginTop: "1vh",
                        }}
                      >
                        {Math.abs(item.discount) > 0 ? item.discountName ? <img src={Offers} alt="" width={12} height={12} style={{ marginTop: "-2px" }} /> : "" : ""}{" "}
                        {Math.abs(item.discount) > 0 ? item.discountName || "" : ""}{" "}
                      </span>
                    </Row>
                  </div>
                </div>
              );
            })}
        </InfiniteScroll>
      </Scrollbars>
      </div>
      <div
        style={{
          padding: "1vh 0.6vw",
          width: "100%",
        }}
      >
        <div
          onClick={() => showCharges(!charges)}
          style={{
            cursor: "pointer",
            fontWeight: 500,
            fontSize: "1em",
            background: "#F3F4F9",
            padding: "0.5vh 0.5vw",
            borderRadius: "5px",
            marginBottom: "1vh",
          }}
        >
          View Details {charges ? "▲" : "▼"}
        </div>
        {charges && (
          <Scrollbars style={{ height: "18vh" }}>
            <Space
              direction="vertical"
              style={{
                width: "100%",
                background: "#F3F4F9",
                padding: "1vh 0.5vw",
                borderRadius: "10px",
                rowGap: "4px",
              }}
            >
              {/* ───────────── Sub-total ───────────── */}
              <Space style={{ width: "100%", justifyContent: "space-between" }}>
                <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Subtotal")}</Text>
                <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                  {(cart.total - cart.tax).toFixed(pricePrecision)}
                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                </Text>
              </Space>

              {/* ───────────── Discount ───────────── */}
              <Space style={{ width: "100%", justifyContent: "space-between" }}>
                <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Discount Sales")}</Text>
                <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                  {parseFloat(cart.discount || 0).toFixed(pricePrecision)}
                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                </Text>
              </Space>

              {/* ───────────── Sales tax ───────────── */}
              <Space style={{ width: "100%", justifyContent: "space-between" }}>
                <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Total Sales Tax")}</Text>
                <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                  {parseFloat(cart.tax || 0).toFixed(pricePrecision)}
                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                </Text>
              </Space>

              {/* ───────────── Service Charge ───────────── */}
              {parseFloat(cart.serviceCharge || 0) > 0 && (
                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                  <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Service Charge")}</Text>
                  <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                    {parseFloat(cart.serviceCharge).toFixed(pricePrecision)}
                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                  </Text>
                </Space>
              )}

              {/* ───────────── Tip ───────────── */}
              {parseFloat(cart.tip || 0) > 0 && (
                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                  <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Tip")}</Text>
                  <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                    {parseFloat(cart.tip).toFixed(pricePrecision)}
                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                  </Text>
                </Space>
              )}

              {/* ───────────── Delivery Charge ───────────── */}
              {parseFloat(cart.deiveryCharge || cart.deliveryCharge || 0) > 0 && (
                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                  <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Delivery Charge")}</Text>
                  <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                    {parseFloat(cart.deiveryCharge || cart.deliveryCharge).toFixed(pricePrecision)}
                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                  </Text>
                </Space>
              )}

              {/* ───────────── Packing Charge ───────────── */}
              {parseFloat(cart.packingCharge || 0) > 0 && (
                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                  <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Packing Charge")}</Text>
                  <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                    {parseFloat(cart.packingCharge).toFixed(pricePrecision)}
                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                  </Text>
                </Space>
              )}

              {/* ───────────── Round Off ───────────── */}
              {cart.roundOff !== 0 && cart.roundOff !== undefined && (
                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                  <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Round Off")}</Text>
                  <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                    {parseFloat(cart.roundOff).toFixed(pricePrecision)}
                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                  </Text>
                </Space>
              )}

              {/* ───────────── Existing Payment List ───────────── */}
              <Space direction="vertical" style={{ width: "100%", padding: 0 }} size={3}>
                {cart?.payments?.map((item, index) => (
                  <div key={index} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                    <Text style={{ fontSize: "1em", fontWeight: 500, color: "#008000", fontFamily: "Inter" }}>
                      {item.name.toLowerCase() === "card" ? `${item.name}${item.authorization ? ` - ${item.authorization}` : ""}` : item.name} {getMultilingualText("Payment")}
                    </Text>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: "1em",
                          fontWeight: 500,
                          color: "#008000",
                          fontFamily: "Inter",
                          margin: 0,
                        }}
                      >
                        {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        &nbsp;
                        {parseFloat(item.amount).toFixed(pricePrecision)}
                        {currenciesList[0].symbolRightSide === "Y" ? ` ${currenciesList[0].currSymbol}` : ""}
                      </Text>

                      <img
                        src={DeleteImg}
                        onClick={() => handleDeletePayment(item)}
                        style={{
                          height: "15px",
                          width: "15px",
                          cursor: "pointer",
                          display: "block",
                          flexShrink: 0,
                        }}
                      />
                    </div>
                  </div>
                ))}

                {/* ───────────── Processed Payment Data ───────────── */}
                {cart?.paymentData?.map((item, index) => (
                  <div key={`pd-${index}`} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                    <Text style={{ fontSize: "1em", fontWeight: 500, color: "#008000", fontFamily: "Inter" }}>
                      {item.name.toLowerCase() === "card" ? `${item.name}${item.authorization ? ` - ${item.authorization}` : ""}` : item.name} {getMultilingualText("Payment")}
                    </Text>
                    <Text style={{ fontSize: "1em", fontWeight: 500, color: "#008000", fontFamily: "Inter" }}>
                      {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                      &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                    </Text>
                  </div>
                ))}
              </Space>
            </Space>
          </Scrollbars>
        )}
        <Space style={{ width: "100%", justifyContent: "space-between", marginTop: "2px" }}>
          <Text style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: 600 }}>{getMultilingualText("Total Amount")}</Text>
          <Text style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: 600 }}>
            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
            {(
              Math.round(
                (parseFloat(cart.total) +
                  parseFloat(cart.serviceCharge || 0) +
                  parseFloat(cart.tip || 0) +
                  parseFloat(cart.deiveryCharge || cart.deliveryCharge || 0) +
                  parseFloat(cart.packingCharge || 0)) *
                  10 ** pricePrecision
              ) / 10 ** pricePrecision
            ).toFixed(pricePrecision)}
            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
          </Text>
        </Space>
        <div>
          <Space direction="horizontal" style={{ paddingTop: "1.5vh", fontSize: "1vw" }}>
            {tillData?.tillAccess?.manualDiscount === "Y" && (
              <Button
                style={{
                  width: "27.1vw",
                  border: "1px solid rgba(146, 144, 152, 0.5)",
                  borderRadius: "10px",
                  color: "#2F3856",
                  height: "5.5vh",
                  fontSize: "1em",
                  fontWeight: "500",
                  marginLeft: "0.3em",
                }}
                onClick={manualDiscountRestaurant}
              >
                <img src={DiscountIcon} style={{ paddingRight: "0.3rem", height: "2.5vh" }} />
                <span>Add Discount</span>
              </Button>
            )}
            {/* <Button
              style={{
                width: "13.5vw",
                borderRadius: "10px",
                color: "#2F3856",
                height: "5.5vh",
                fontSize: "1em",
                fontWeight: "500",
              }}
            >
              <img src={printBill} style={{ paddingRight: "0.3rem", height: "2.5vh" }} />
              <span>Print Bill</span>
            </Button> */}
          </Space>
        </div>
        <div>
          <Space direction="horizontal" style={{ paddingTop: "2vh" }}>
            <Button
              disabled={restaurantButtonLoading}
              loading={restaurantButtonLoading}
              onClick={async () => {
                if (restaurantButtonLoading) return;
                if (usePOSConfigStore.getState().posConfig?.disableOfflineBilling === "Y" && !navigator.onLine) {
                  message.warning("Network is unavailable. Please check your connection before completing the bill.");
                  return;
                }
                try {
                  setRestaurantButtonLoading?.(true);
                  // Force a paint before the (sometimes microtask-fast) completion work runs, or the spinner never becomes visible
                  await new Promise((resolve) => setTimeout(resolve, 100));
                  if (!selectedPayment && paymentVisible) {
                    message.warning(`${messages.warnings.payment.select_payment_method}`);
                    return;
                  }
                  const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                  const denominationsValue = filtredCurrencies[0]?.value || 1;
                  const scale = 100; // For 2 decimal places
                  const scaledDividend = Math.round(amount * scale); // 1040
                  const scaledDivisor = Math.round(denominationsValue * scale); // 20

                  const scaledRemainder = scaledDividend % scaledDivisor;
                  const remainder = scaledRemainder / scale;
                  const isGiftCardOrLoyalty =
                    selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                    selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                    selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                  if (isGiftCardOrLoyalty && paymentVisible) {
                    if (parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                      if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && remainder !== 0) {
                        message.warning(`${messages.warnings.payment.payment_multiple_check} ${denominationsValue}`);
                      } else if (selectedPaymentMethod?.enablePaymentData && selectedPaymentMethod?.paymentDataFields?.length > 0) {
                        // TSK-2934: selectedPaymentMethod.enablePaymentData (per-payment-method,
                        // from getTillData) is unrelated to posConfig.enablePaymentData.
                        setPaymentDataPopupOpen(true);
                        return;
                      } else {
                        await completeGiftCardOrLoyaltyPayment();
                      }
                    } else {
                      processOrder();
                    }
                  } else if (paymentVisible === false) {
                    setPaymentVisible(true);
                  }
                } catch (error) {
                  console.error("Payment Error:", error);
                } finally {
                  setRestaurantButtonLoading?.(false);
                }
              }}
              style={{
                width: "27.8vw",
                borderRadius: "10px",
                backgroundColor: restaurantButtonLoading ? "#92909880" : paymentVisible ? (selectedPayment ? "#2F3856" : "#92909880") : "#2F3856",
                color: "#fff",
                height: "6vh",
                fontSize: "1em",
                fontWeight: 500,
              }}
            >
              {paymentVisible ? `${getMultilingualText("Add Payment")}` : `${getMultilingualText("Pay Bill")}`}
            </Button>
          </Space>
        </div>
      </div>
      {paymentDataPopupOpen && (
        <PaymentDataPopup
          open={paymentDataPopupOpen}
          selectedPaymentMethod={selectedPaymentMethod}
          amount={amount}
          currencySymbol={currenciesList?.[0]?.currSymbol}
          onSubmit={handlePaymentDataConfirm}
          onCancel={() => setPaymentDataPopupOpen(false)}
        />
      )}
    </div>
  );
};

export default React.memo(OrderDetailsSidebar);
